export const NON_PRODUCTION_EVENT_TYPE_CODES = ["D", "M", "H"] as const;

const STACK_PRIORITY: Record<string, number | undefined> = {
	H: 3,
	D: 2,
	M: 1,
};

export const isNonProductionEventType = (
	eventTypeCode: string | null | undefined,
): boolean => STACK_PRIORITY[eventTypeCode ?? ""] !== undefined;

export interface NonProductionStackItem {
	start: number;
	end: number;
	eventTypeCode?: string | null;
	createdAt?: number | null;
	eventId?: number | null;
}

export const compareNonProductionByEnd = (
	a: NonProductionStackItem,
	b: NonProductionStackItem,
): number => {
	if (a.end !== b.end) return a.end - b.end;

	const priorityA = STACK_PRIORITY[a.eventTypeCode ?? ""] ?? 0;
	const priorityB = STACK_PRIORITY[b.eventTypeCode ?? ""] ?? 0;
	if (priorityA !== priorityB) return priorityB - priorityA;

	const createdA = a.createdAt ?? 0;
	const createdB = b.createdAt ?? 0;
	if (createdA !== createdB) return createdB - createdA;

	return (b.eventId ?? 0) - (a.eventId ?? 0);
};

export const compareNonProductionStack = (
	a: NonProductionStackItem,
	b: NonProductionStackItem,
): number => b.start - a.start || compareNonProductionByEnd(a, b);

export const compareNonProductionChronological = (
	a: NonProductionStackItem,
	b: NonProductionStackItem,
): number => a.start - b.start || compareNonProductionByEnd(a, b);
